var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5997_133522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5997_133522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.58336 27.9998V23.9998H2.68336C2.15002 23.9998 1.76113 23.7665 1.51669 23.2998C1.27224 22.8332 1.29447 22.3776 1.58336 21.9332L5.38336 15.9998C4.87224 15.9998 4.48891 15.7721 4.23336 15.3165C3.9778 14.8609 4.00558 14.4109 4.31669 13.9665L11.15 4.23317C11.4167 3.85539 11.7834 3.6665 12.25 3.6665C12.7167 3.6665 13.0834 3.85539 13.35 4.23317L16.25 8.39984L19.15 4.23317C19.4167 3.85539 19.7834 3.6665 20.25 3.6665C20.7167 3.6665 21.0834 3.85539 21.35 4.23317L28.1834 13.9665C28.4945 14.4109 28.5222 14.8609 28.2667 15.3165C28.0111 15.7721 27.6278 15.9998 27.1167 15.9998L30.9167 21.9332C31.2056 22.3776 31.2278 22.8332 30.9834 23.2998C30.7389 23.7665 30.35 23.9998 29.8167 23.9998H22.9167V27.9998C22.9167 28.3776 22.7889 28.6943 22.5334 28.9498C22.2778 29.2054 21.9611 29.3332 21.5834 29.3332H18.9167C18.5389 29.3332 18.2222 29.2054 17.9667 28.9498C17.7111 28.6943 17.5834 28.3776 17.5834 27.9998V23.9998H14.9167V27.9998C14.9167 28.3776 14.7889 28.6943 14.5334 28.9498C14.2778 29.2054 13.9611 29.3332 13.5834 29.3332H10.9167C10.5389 29.3332 10.2222 29.2054 9.96669 28.9498C9.71113 28.6943 9.58336 28.3776 9.58336 27.9998ZM22.55 21.3332H27.3834L22.2167 13.3332H24.45L20.25 7.33317L17.8834 10.6998L20.1834 13.9665C20.4945 14.4109 20.5222 14.8609 20.2667 15.3165C20.0111 15.7721 19.6278 15.9998 19.1167 15.9998L22.55 21.3332ZM5.11669 21.3332H19.3834L14.2167 13.3332H16.45L12.25 7.33317L8.05002 13.3332H10.2834L5.11669 21.3332ZM5.11669 21.3332H10.2834H8.05002H16.45H14.2167H19.3834H5.11669ZM22.55 21.3332H19.1167H21.5834H17.8834H24.45H22.2167H27.3834H22.55Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegna);
export default __webpack_public_path__ + "static/media/legna.6830a8d75ad0271e267435600b18b997.svg";
export { ForwardRef as ReactComponent };